import { useState, useRef } from "react";
import BiodataPreview from "./BiodataPreview";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function BiodataContainer({ sections, template ,  userImage }) {
  const previewRef = useRef();
  const [imgLoaded, setImgLoaded] = useState(false);

  const downloadPDF = async () => {
    if (!previewRef.current) return;

    if (!imgLoaded) {
      alert("Please wait until the template image is fully loaded");
      return;
    }

    const pages = previewRef.current.querySelectorAll(".bd-page");
    const pdf = new jsPDF("p", "pt", "a4");

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: false,     // ✅ base64 image → no CORS needed
        allowTaint: false,
        backgroundColor: null,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    }

    pdf.save("biodata.pdf");
  };
  // const [userImage, setUserImage] = useState(
  //   localStorage.getItem("bdm_user_image") || null
  // );
  return (
    <div className="preview-outer">
   <div className="preview-scale">
    <div ref={previewRef} className="maincontainer">
      <BiodataPreview
        sections={sections}
        template={template}    userImage={userImage}
        onImgLoad={() => setImgLoaded(true)}
      />
    </div>
  </div>
   <div className="bg-white p-3 mt-3 mb-4 rounded-lg text-center shadow-sm">
    <button className="download-btn btn btn-md btn-primary" onClick={downloadPDF}>
    Download Biodata
  </button>
   </div>
  
</div>
  );
}
